import React, { useState } from "react";
import "./buttomG.css";
import { useTranslation } from "react-i18next";
import GalleryGrid from "./GalleryGrid";
import { GALLERIES, GALLERY_ORDER } from "../../constants/galleries";
import { isRtlLanguage } from "../../utils/i18n";

function ButtonGroup() {
  const [activeElement, setActiveElement] = useState("element1");
  const { t, i18n } = useTranslation();
  const isRtl = isRtlLanguage(i18n.language);
  const activeGallery = GALLERIES[activeElement];

  return (
    <div>
      <div
        className="gallery-tabs mb-6 flex gap-2 overflow-x-auto pb-2 sm:mb-8 sm:flex-wrap sm:justify-center sm:gap-3 sm:overflow-visible lg:flex-nowrap"
        role="tablist"
        aria-label={t("Our Projects")}
        dir={isRtl ? "rtl" : "ltr"}
      >
        {GALLERY_ORDER.map((id) => {
          const isActive = activeElement === id;
          return (
            <button
              key={id}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`gallery-tab b shrink-0 rounded-border px-3 py-2 text-xs font-normal transition-colors sm:px-4 sm:py-3 sm:text-sm md:text-base ${
                isActive ? "is-active" : ""
              }`}
              onClick={() => setActiveElement(id)}
            >
              {t(GALLERIES[id].buttonKey)}
            </button>
          );
        })}
      </div>

      <div role="tabpanel">
        <GalleryGrid
          key={activeElement}
          images={activeGallery.images}
          descriptionKey={activeGallery.descriptionKey}
        />
      </div>
    </div>
  );
}

export default ButtonGroup;
